import React from 'react';

const CircleMoneyBag = () => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-789.000000, -233.000000)" fill="#FFFFFF">
        <g transform="translate(772.000000, 115.000000)">
          <g>
            <g>
              <g transform="translate(17.000000, 118.000000)">
                <g opacity="0.300409226">
                  <circle cx="16" cy="16" r="16"></circle>
                </g>
                <g transform="translate(8.000000, 5.333333)" fillRule="nonzero">
                  <g>
                    <path d="M8,4.66666667 C8.40728889,4.66666667 8.81248,4.69499 9.20416,4.75163668 C9.73436444,4.82715364 10.1333333,5.28770328 10.1333333,5.82269567 C10.1333333,5.90669889 10.1002667,5.98282458 10.0815644,6.06299645 C12.8904178,6.95552174 14.9333333,9.63882672 14.9333333,12.7585116 L14.9333333,12.7585116 L14.9333333,13.850088 C15.6593067,14.3898069 16,15.1806762 16,15.9811416 C16,17.4670247 14.8057956,18.6666667 13.3333333,18.6666667 L13.3333333,18.6666667 L2.66666667,18.6666667 C1.19121778,18.6666667 0,17.4640169 0,15.9811416 C0,15.1746248 0.347057778,14.3851162 1.06666667,13.8500164 L1.06666667,13.8500164 L1.06666667,12.7585116 C1.06666667,9.63875511 3.10951111,6.95545012 5.91843556,6.06299645 C5.89973333,5.98278877 5.86666667,5.90669889 5.86666667,5.82269567 C5.86666667,5.28766747 6.26613333,4.82715364 6.79633778,4.75163668 C7.18801778,4.69499 7.59271111,4.66666667 8,4.66666667 Z M6.93637847,9.82456144 L6,9.82456144 L6,10.8065614 L5,10.8070176 L5,11.7894737 L6,11.7885614 L6,13.7535614 L5,13.7543859 L5,14.7368421 L6,14.7365614 L6,15.719298 L6.93637847,15.719298 L6.936,14.7365614 L8.512,14.7365614 L9.03752039,15.719298 L10,15.719298 L10,14.7365614 L11,14.7368421 L11,13.7543859 L10,13.7535614 L10,11.7885614 L11,11.7894737 L11,10.8070176 L10,10.8065614 L10,9.82456144 L9.06035889,9.82456144 L9.06,10.8065614 L7.457,10.8065614 L6.93637847,9.82456144 Z M6.94942904,11.8137818 L7.986,13.7535614 L6.936,13.7535614 L6.93637847,11.8137818 L6.94942904,11.8137818 Z M9.06,11.7885614 L9.06,13.7535614 L9.019,13.7535614 L7.977,11.7885614 L9.06,11.7885614 Z"></path>
                    <path d="M5.14285723,0 L5.14285723,0.554230095 C5.14285723,1.67089289 5.6022477,2.73874649 6.38224767,3.5 C6.86544766,3.39676541 7.52544763,3.36288347 8,3.36288347 C8.47641903,3.36288347 9.13024758,3.39635897 9.61782852,3.49988915 C10.3977523,2.73867259 10.8571428,1.67081899 10.8571428,0.554230095 L10.8571428,0 L5.14285723,0 Z"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default CircleMoneyBag;
